import { OmsInsightSchema } from "@redotech/redo-fulfillment-common/oms-insight";
import * as z from "zod";

export const getOmsInsights = {
  name: "getOmsInsights" as const,
  input: z.object({}),
  output: z.object({ insights: z.array(OmsInsightSchema) }),
};
